import { bffServiceClient } from 'packages/request/clients';
import { getData } from 'helpers/request';
import { IGetDailyReportParams, IGetDailyReportResponse } from 'interfaces';

const getDailyReport = (
  params: IGetDailyReportParams
): Promise<IGetDailyReportResponse> => {
  return bffServiceClient.get('/jobProcessStatistic', { params }).then(getData);
};

const exportDailyShops = (
  params: IGetDailyReportParams
): Promise<{ filePath: string }> => {
  return bffServiceClient
    .get('/jobProcessStatistic/export', { params })
    .then(getData);
};

export default {
  getDailyReport,
  exportDailyShops,
};
